import loginPrompt from './loginPrompt';
import { ruleConfigTradeOnboarding } from './tradeOnboarding';
import mobileAds from './mobileAds';
import abandonCheckout from './abandonCheckout/index';
import collabPurchasing from './collaborativePurchasing';
import workspaceIntro from './workspaceIntroduction';

export default [
    loginPrompt,
    ruleConfigTradeOnboarding,
    mobileAds,
    collabPurchasing,
    workspaceIntro,
    ...abandonCheckout,
];
